import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadUsersOperation = 'ReadUsersV3'
export type ReadUsersParams = OpalApiRequestParams<ReadUsersOperation>
export type ReadUsersResponse = OpalApiResponseDocument<ReadUsersOperation, 200>

export function readUsers(params: ReadUsersParams): Promise<ReadUsersResponse> {
  const url = new URL(`/users/v3/users`, window.location.origin)
  url.search = queryString({
    ...params.query,
    filter: {
      ...params.query.filter,
    },
    page: {
      limit: 500,
      ...params.query.page,
    },
  })

  return HttpClient()
    .get<ReadUsersResponse>(url.toString())
    .then((res) => res.data)
}
